import { render } from "./CalendarHistoryWarningIcon.vue?vue&type=template&id=f9c60980"
import script from "./CalendarHistoryWarningIcon.vue?vue&type=script&lang=js"
export * from "./CalendarHistoryWarningIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__